import { MatDialog } from '@angular/material/dialog';
import { SacPurposeDialogComponent } from './../../../common/sac-purpose/components/sac-purpose-dialog/sac-purpose-dialog.component';
import { SignupService } from './../../../shared/services/signup/signup.service';
import { VariablesService } from './../../../shared/services/variables/variables.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ICampaign } from '../../../shared/models/campaign.model';
import { CampaignService, UtilService, EventsService } from '../../../shared/services';
import { FORM_TEXTS } from '../objects/placeholder';
import { StartAFrUrls } from 'src/app/shared/models/start-fr-urls';

@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.scss']
})
export class CampaignComponent implements OnInit, OnDestroy {

  param: string;
  draft: ICampaign;
  draftId;
  type;
  entityId;
  causes;
  info;
  mergedCause = [];
  draftChecked: boolean;
  draftData;

  startAFrUrls = StartAFrUrls;

  constructor(
    public actRoute: ActivatedRoute,
    public router: Router,
    public util: UtilService,
    public campaignService: CampaignService,
    public events: EventsService,
    public vars: VariablesService,
    public signupService: SignupService,
    private dialog: MatDialog,
  ) {
    if (!this.actRoute.snapshot.queryParams.saf_source) {
      this.router.navigate([], { queryParams: { saf_source: this.vars.pageName }, queryParamsHandling: 'merge' });
    }
  }

  ngOnInit() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('bg-gray');
    }
    // this.getDraft();
    this.getParam();
    this.setLanguage();
  }
  /** Get the URL Activated URL */
  getActivatedURl() {
    if (typeof window !== 'undefined') {
      if (window && window.location) {
        this.util.siteUrl.next(window.location.origin);
      }
    }
  }
  /**
   * Get URL params
   */
  getParam() {
    this.actRoute.params.subscribe(param => {
      this.param = param['id'];
      this.util.param.next(this.param);
    });
    const entity_type = this.actRoute.snapshot.queryParams['entity_type'];
    const entity_id = this.actRoute.snapshot.queryParams['entity_id'];
    if (entity_type && entity_id) {
      this.campaignService.micrositeCampaigns.entity_type = entity_type;
      this.campaignService.micrositeCampaigns.entity_id = entity_id;
    }
    this.getEntityId();
    this.getDraftId();
    this.getActivatedURl();
    this.sendSystemEventOnLoad();
    this.vars.pageName = 'non-medical-sac';
  }

  /**
   * Get draft id from URL query params
   */
  getDraftId() {
    this.actRoute.queryParams.subscribe(async param => {
      this.draftId = this.actRoute.snapshot.queryParams['did'];
      const type = this.actRoute.snapshot.queryParams['type'];
      this.util.campaignType.next(type);
      if (this.draftId) {
        this.getDraftById(type);
      } else {
        const isDraftExist = await this.signupService.checkForDraft(false);
        if (isDraftExist && this.param !== 'image') {
          this.signupService.draftRedirection();
        }
        // this.router.navigate(
        //   [this.startAFrUrls['non-medical'], 'basic'],
        //   { queryParams: { type: type }, queryParamsHandling: 'merge' }
        // );
        this.draftId = this.actRoute.snapshot.queryParams['did'];
        this.checkForDraft();
        this.draftChecked = true;
      }
    });
  }
  /**Get Entity id from local storage */
  getEntityId() {
    const data = this.util.getUserData();
    this.entityId = data.id;
  }
  /**
   * Get draft details
   */
  getDraft() {
    this.vars.draftObs.subscribe((res) => {
      this.draft = res;
    });
  }
  /**
   * Get draft details from API
   */
  getDraftById(type) {
    this.campaignService.getCampaignDraft(this.draftId).subscribe({ next:
      async (res: any) => {
        this.draft = res.data;
        this.vars.draftObs.next(res.data);
        if (res.data.event_entity_details_id) {
          this.campaignService.micrositeCampaigns.entity_type = 'events';
          this.campaignService.micrositeCampaigns.entity_id = res.data.event_entity_details_id;
        }
        if (res.data.parent_cause_id !== 48) {
          this.getMergedCauses(res.data.parent_cause_id);
        }
        const isDraftExist = await this.signupService.checkForDraft(false);
        if (isDraftExist && this.param !== 'image') {
          this.signupService.draftRedirection();
        }
      },
      error: (error) => {
        this.router.navigate(
          [this.startAFrUrls['non-medical'], 'basic'],
          { queryParams: { type: type }, queryParamsHandling: 'merge' }
        );
      }
    });
  }
  getMergedCauses(id?) {
    this.campaignService.getMergedCauses().subscribe((res: any) => {
      /** Concat merged causes into one array */
      this.mergedCause = [].concat(res.data.causes[0].child, res.data.causes[1].child);
      /** Removing Medical cause from merged causes */
      this.mergedCause = this.mergedCause.filter((cause) => cause.id !== 59);
      /** Sort array alphabetically */
      this.mergedCause.sort(function (a, b) {
        if (a.info_1 < b.info_1) { return -1; }
        if (a.info_1 > b.info_1) { return 1; }
        return 0;
      });
      this.causes = this.util.setArray(this.mergedCause, 'id', 'info_1');
    });
  }
  /**Get the causes */
  getCauses(id) {
    this.campaignService.getCauses(id).subscribe((res: any) => {
      this.causes = this.util.setArray(res.data.child, 'id', 'info_1');
    });
  }
  // System push on load
  sendSystemEventOnLoad() {
    const payload = {
      eventName: 'pageView',
      event_type: '',
      page_name: 'start_new_campaign'
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
  }

  async checkForDraft() {
    if (this.draftChecked) {
      return true;
    }
    const isDraftExist = await this.signupService.checkForDraft(false);
    const type = this.actRoute.snapshot.queryParams['type'];
    if (!isDraftExist && !this.vars.purposeSelected && !this.campaignService.micrositeCampaigns.entity_id && !type) {
      const dialogRef = this.dialog.open(SacPurposeDialogComponent, {
        panelClass: 'sac-purpose-changer',
        data: {
          showWarningText: false,
          frType: 'medical'
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          const sacInitiatedPayload = this.util.storage.getFromSession('sac-initiated');
          const sacPuposeSelected = this.util.storage.getFromSession('sac-purpose-selected');
          if (!sacPuposeSelected) {
            const payload = {
              eventName: 'cause_selection',
              page_name: this.vars.pageName,
              info_1: sacInitiatedPayload.info_1 || '',
              info_2: sacInitiatedPayload.info_2 || '',
              info_4: result.data,
              event_type: 'campaign'
            };
            this.events.systemEventPush(payload);
            this.util.storage.addSessionData('sac-purpose-selected', { 'purpose': result.data });
          }
          const path = result.data === 'medical' ?
            this.startAFrUrls.medical :
            this.startAFrUrls['non-medical'];
          this.router.navigate([path], { queryParams: { type: result.data }, queryParamsHandling: 'merge' });
        }
      });
    }
  }

  setLanguage(data?) {
    const lang = this.util.storage.get('language');
    this.info = lang ? FORM_TEXTS[lang] : FORM_TEXTS['English'];
  }

  /**
   * Called once, before the instance is destroyed.
   * Add 'implements OnDestroy' to the class.
   */
  ngOnDestroy(): void {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('bg-gray');
    }
  }


}
